"use strict";
exports.__esModule = true;
exports.SHADOW = exports.BORDER_COLORS = exports.REVERSE_COLORS = exports.COLORS = void 0;
exports.COLORS = {
    inherit: '!bg-inherit-100',
    primary: '!bg-primary-100',
    danger: '!bg-danger-100',
    warning: '!bg-warning-100',
    control: '!bg-control-100',
    success: '!bg-success-100',
    info: '!bg-info-100',
    secondary: '!bg-secondary-100',
    tertiary: '!bg-tertiary-100',
    white: '!bg-white',
    slate: '!bg-slate-100',
    zinc: '!bg-zinc-100',
    neutral: '!bg-neutral-100',
    stone: '!bg-stone-100',
    red: '!bg-red-100',
    orange: '!bg-orange-100',
    amber: '!bg-amber-100',
    yellow: '!bg-yellow-100',
    lime: '!bg-lime-100',
    green: '!bg-green-100',
    emerald: '!bg-emerald-100',
    teal: '!bg-teal-100',
    cyan: '!bg-cyan-100',
    sky: '!bg-sky-100',
    blue: '!bg-blue-100',
    indigo: '!bg-indigo-100',
    violet: '!bg-violet-100',
    purple: '!bg-purple-100',
    fuchsia: '!bg-fuchsia-100',
    pink: '!bg-pink-100',
    rose: '!bg-rose-100'
};
exports.REVERSE_COLORS = {
    primary: '!bg-primary-light',
    secondary: '!bg-secondary-light',
    tertiary: '!bg-tertiary-light',
    info: '!bg-info-light',
    danger: '!bg-danger-light',
    warning: '!bg-warning-light',
    success: '!bg-success-light',
    control: '!bg-control-light',
    inherit: '!bg-inherit',
    white: '!bg-control-100',
    slate: '!bg-slate-300',
    zinc: '!bg-zinc-300',
    neutral: '!bg-neutral-300',
    stone: '!bg-stone-300',
    red: '!bg-red-300',
    orange: '!bg-orange-300',
    amber: '!bg-amber-300',
    yellow: '!bg-yellow-300',
    lime: '!bg-lime-300',
    green: '!bg-green-300',
    emerald: '!bg-emerald-300',
    teal: '!bg-teal-300',
    cyan: '!bg-cyan-300',
    sky: '!bg-sky-300',
    blue: '!bg-blue-300',
    indigo: '!bg-indigo-300',
    violet: '!bg-violet-300',
    purple: '!bg-purple-300',
    fuchsia: '!bg-fuchsia-300',
    pink: '!bg-pink-300',
    rose: '!bg-rose-300'
};
exports.BORDER_COLORS = {
    primary: 'border-primary',
    secondary: 'border-secondary',
    tertiary: 'border-tertiary',
    info: 'border-info',
    danger: 'border-danger',
    warning: 'border-warning',
    success: 'border-success',
    control: 'border-control',
    inherit: 'border-tertiary',
    white: 'border-white',
    slate: 'border-slate-500',
    zinc: 'border-zinc-500',
    neutral: 'border-neutral-500',
    stone: 'border-stone-500',
    red: 'border-red-500',
    orange: 'border-orange-500',
    amber: 'border-amber-500',
    yellow: 'border-yellow-500',
    lime: 'border-lime-500',
    green: 'border-green-500',
    emerald: 'border-emerald-500',
    teal: 'border-teal-500',
    cyan: 'border-cyan-500',
    sky: 'border-sky-500',
    blue: 'border-blue-500',
    indigo: 'border-indigo-500',
    violet: 'border-violet-500',
    purple: 'border-purple-500',
    fuchsia: 'border-fuchsia-500',
    pink: 'border-pink-500',
    rose: 'border-rose-500'
};
exports.SHADOW = {
    'none': 'shadow-none',
    'xs': 'shadow-sm',
    'sm': 'shadow',
    'md': 'shadow-md',
    'lg': 'shadow-lg',
    'xl': 'shadow-xl',
    '2xl': 'shadow-2xl',
    'inner': 'shadow-inner'
};
//# sourceMappingURL=card.style.js.map